import { collection, getDocs, doc, getDoc, query, where } from 'firebase/firestore';
import { db } from './firebaseConfig';

const academyData = {
  // Obtener todos los cursos
  getCourses: async () => {
    try {
      // AGREGAR FILTRO
      const querySnapshot = await getDocs(
        query(
          collection(db, 'academyCourses'),
          where('isPublished', '==', true) // FILTRA SOLO LOS PUBLICADOS
        )
      );
      
      const courses = querySnapshot.docs.map(doc => ({ 
        id: doc.id, 
        ...doc.data() 
      }));
      console.log(`Cursos publicados encontrados: ${courses.length}`);
      return courses;
    } catch (error) {
      console.error('Error al obtener cursos publicados:', error);
      return [];
    }
  },

  getAllCourses: async () => {
    try {
      const querySnapshot = await getDocs(collection(db, 'academyCourses'));
      const courses = querySnapshot.docs.map(doc => ({ 
        id: doc.id, 
        ...doc.data() 
      }));
      
      console.log(`Todos los cursos encontrados: ${courses.length}`);
      return courses;
    } catch (error) {
      console.error('Error al obtener todos los cursos:', error);
      return [];
    }
  },

  getColor: async () => {
    const querySnapshot = await getDocs(collection(db, 'colors'));
    const colors = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    return colors;
  },

  // Obtener los detalles de un curso específico
  getCourseById: async (courseId) => {
    const courseRef = doc(db, 'academyCourses', courseId);
    const courseSnap = await getDoc(courseRef);
    
    if (courseSnap.exists()) {
      return { id: courseSnap.id, ...courseSnap.data() };
    } else {
      throw new Error('Curso no encontrado');
    }
  },

  // Obtener los módulos de un curso
  getModulesByCourseId: async (courseId) => {
    const course = await academyData.getCourseById(courseId);
    return course.modules || []; // Asumiendo que los módulos están dentro de un array en los datos del curso
  },

  // Obtener todos los módulos de todos los cursos
  getAllModules: async () => {
    const courses = await academyData.getCourses();
    const allModules = [];

    courses.forEach(course => {
      const modules = course.modules || [];
      allModules.push(...modules); // Agrega todos los módulos al array
    });

    return allModules;
  },
  // Obtener los grupos asignados a un tutor
  getGroupsByTutorId: async (tutorId) => {
    const groupsQuery = query(collection(db, 'groups'), where('mentor.uid', '==', tutorId));
    const querySnapshot = await getDocs(groupsQuery);
    return querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  },

  // Obtener los estudiantes de un grupo específico
  getStudentsByGroupId: async (groupId) => {
    const groupRef = doc(db, 'groups', groupId);
    const groupSnap = await getDoc(groupRef);
    
    if (groupSnap.exists()) {
      const groupData = groupSnap.data();
      return groupData.students || [];
    } else {
      throw new Error('Grupo no encontrado');
    }
  },

  getGroupById: async (groupId) => {
    const groupRef = doc(db, 'groups', groupId);
    const groupSnap = await getDoc(groupRef);
    
    if (groupSnap.exists()) {
        return { id: groupSnap.id, ...groupSnap.data() };
    } else {
        throw new Error('Grupo no encontrado');
    }
  },

  // Obtener los grupos donde está el estudiante
  getGroupsByStudentId: async (studentId) => {
    // Primero obtenemos todos los grupos
    const groupsSnapshot = await getDocs(collection(db, 'groups'));
    
    // Luego filtramos manualmente los grupos donde el estudiante está presente
    const studentGroups = groupsSnapshot.docs
        .map(doc => ({ id: doc.id, ...doc.data() }))
        .filter(group => 
            group.students?.some(student => student.uid === studentId)
        );

    return studentGroups;
  },

  // Obtener una actividad específica por su ID
  getActivityById: async (activityId) => {
    try {
        const guideRef = doc(db, 'practicalGuide', activityId);
        const guideSnap = await getDoc(guideRef);
        
        if (guideSnap.exists()) {
            const guideData = guideSnap.data();
            
            const components = guideData.project?.components || [];
            const connections = guideData.project?.connections || [];
            const code = guideData.project?.code || '';
            
            const currentStepIntroduction = Array.isArray(guideData.currentStepIntroduction) ?
                guideData.currentStepIntroduction : [];
            
            return {
                id: guideSnap.id,
                ...guideData,
                components: components,
                connections: connections,
                code: code,
                currentStepIntroduction: currentStepIntroduction,
                name: guideData.name || guideData.project?.name,
                InitialProjectDescription: guideData.InitialProjectDescription || '',
                introduction: guideData.introduction || [],
                titleIntroduction: guideData.titleIntroduction || ''
            };
        }

        const coursesSnapshot = await getDocs(collection(db, 'academyCourses'));
        
        for (const courseDoc of coursesSnapshot.docs) {
            const courseData = courseDoc.data();
            
            if (courseData.modules) {
                for (const module of courseData.modules) {
                    if (module.lessons) {
                        for (const lesson of module.lessons) {
                            const foundActivity = lesson.classActivities?.find(
                                activity => activity.id === activityId
                            );
                            
                            if (foundActivity) {
                                const templateRef = doc(db, 'practicalGuide', foundActivity.id);
                                const templateSnap = await getDoc(templateRef);
                                
                                if (templateSnap.exists()) {
                                    const templateData = templateSnap.data();
                                    
                                    const components = Array.isArray(templateData.components) ? 
                                        templateData.components : [];
                                    const connections = Array.isArray(templateData.connections) ? 
                                        templateData.connections : [];
                                    const currentStepIntroduction = Array.isArray(templateData.currentStepIntroduction) ?
                                        templateData.currentStepIntroduction : [];
                                    
                                    return {
                                        id: foundActivity.id,
                                        ...foundActivity,
                                        ...templateData,
                                        components: components,
                                        connections: connections,
                                        currentStepIntroduction: currentStepIntroduction,
                                        courseId: courseDoc.id,
                                        moduleId: module.id
                                    };
                                }
                                
                                return {
                                    id: foundActivity.id,
                                    ...foundActivity,
                                    components: [],
                                    connections: [],
                                    currentStepIntroduction: [],
                                    courseId: courseDoc.id,
                                    moduleId: module.id
                                };
                            }
                        }
                    }
                }
            }
        }

        throw new Error('Actividad no encontrada');
    } catch (error) {
        console.error("Error al buscar actividad:", error);
        throw error;
    }
  },

  // Método auxiliar para obtener todas las actividades de un curso
  getActivitiesByCourseId: async (courseId) => {
    try {
      const course = await academyData.getCourseById(courseId);
      const activities = [];

      if (course.modules) {
        course.modules.forEach(module => {
          module.lessons?.forEach(lesson => {
            if (lesson.classActivities) {
              activities.push(...lesson.classActivities);
            }
          });
        });
      }

      return activities;
    } catch (error) {
      console.error('Error al obtener actividades del curso:', error);
      throw error;
    }
  },

  async getCourseByActivityId(activityId) {
    try {
        const coursesRef = collection(db, 'academyCourses');
        const coursesSnapshot = await getDocs(coursesRef);
        
        let courseInfo = null;
        
        for (const courseDoc of coursesSnapshot.docs) {
            const courseData = courseDoc.data();
            
            if (courseData.modules) {
                for (let i = 0; i < courseData.modules.length; i++) {
                    const module = courseData.modules[i];
                    
                    if (module.lessons) {
                        for (const lesson of module.lessons) {
                            if (lesson.classActivities) {
                                const foundActivity = lesson.classActivities.find(
                                    activity => activity.id === activityId
                                );
                                
                                if (foundActivity) {
                                    courseInfo = {
                                        courseId: courseDoc.id,
                                        courseName: courseData.name,
                                        moduleNumber: (i + 1).toString(),
                                        moduleName: module.name,
                                        mentorId: courseData.mentorId || null,
                                        activityName: foundActivity.name
                                    };
                                    break;
                                }
                            }
                        }
                    }
                    if (courseInfo) break;
                }
            }
            if (courseInfo) break;
        }

        if (!courseInfo) {
            throw new Error('No se encontró información del curso para la actividad');
        }

        return courseInfo;
    } catch (error) {
        console.error("Error al buscar curso por activityId:", error);
        throw error;
    }
  },

  getStudentGroupActivities: async (studentId) => {
    try {
        // Obtener todos los grupos donde está el estudiante
        const studentGroups = await academyData.getGroupsByStudentId(studentId);
        
        // Obtener todas las actividades del estudiante en los grupos
        const groupActivities = [];
        
        for (const group of studentGroups) {
            if (group.activities) {
                // Filtrar las actividades del estudiante que tienen projectUid
                const studentActivities = group.activities.filter(
                    activity => activity.studentUid === studentId && activity.projectUid
                );
                groupActivities.push(...studentActivities);
            }
        }
        
        // Extraer los IDs de los proyectos únicos
        const projectIds = [...new Set(groupActivities.map(activity => activity.projectUid))];
            
        return projectIds;
    } catch (error) {
        console.error('Error getting student group activities:', error);
        return [];
    }
  },

  // Función genérica para obtener una guía por ID y colección
  getGuideByIdFromCollection: async (collectionName, guideId) => {
    const guideRef = doc(db, collectionName, guideId);
    const guideSnap = await getDoc(guideRef);

    if (guideSnap.exists()) {
        const guideData = guideSnap.data();
        const components = guideData.project?.components || [];
        const connections = guideData.project?.connections || [];
        const code = guideData.project?.code || '';
        const currentStepIntroduction = Array.isArray(guideData.currentStepIntroduction)
            ? guideData.currentStepIntroduction : [];
        return {
            id: guideSnap.id,
            ...guideData,
            components,
            connections,
            code,
            currentStepIntroduction,
            name: guideData.name || guideData.project?.name,
            InitialProjectDescription: guideData.InitialProjectDescription || '',
            introduction: guideData.introduction || [],
            titleIntroduction: guideData.titleIntroduction || ''
        };
    }
    throw new Error('Guía no encontrada en ' + collectionName);
  },

  // Nueva función para starterGuide
  getStarterGuideById: async (starterId) => {
    try {
        console.log("[DEBUG] Buscando starter guide con ID:", starterId);
        
        // Intentar en la colección starterGuides
        const guideRef = doc(db, 'starterGuides', starterId);
        const guideSnap = await getDoc(guideRef);
        
        if (guideSnap.exists()) {
            console.log("[DEBUG] Starter guide encontrado en colección 'starterGuides'");
            const guideData = guideSnap.data();
            const components = guideData.project?.components || [];
            const connections = guideData.project?.connections || [];
            const code = guideData.project?.code || '';
            const currentStepIntroduction = Array.isArray(guideData.currentStepIntroduction) ?
                guideData.currentStepIntroduction : [];
            
            return {
                id: guideSnap.id,
                ...guideData,
                components: components,
                connections: connections,
                code: code,
                currentStepIntroduction: currentStepIntroduction,
                name: guideData.name || guideData.project?.name,
                InitialProjectDescription: guideData.InitialProjectDescription || '',
                introduction: guideData.introduction || [],
                titleIntroduction: guideData.titleIntroduction || ''
            };
        }
        
        // Intentar en la colección practicalGuide
        console.log("[DEBUG] Intentando buscar en colección 'practicalGuide'");
        const practicalRef = doc(db, 'practicalGuide', starterId);
        const practicalSnap = await getDoc(practicalRef);
        
        if (practicalSnap.exists()) {
            console.log("[DEBUG] Guide encontrado en colección 'practicalGuide'");
            const guideData = practicalSnap.data();
            const components = guideData.project?.components || [];
            const connections = guideData.project?.connections || [];
            const code = guideData.project?.code || '';
            const currentStepIntroduction = Array.isArray(guideData.currentStepIntroduction) ?
                guideData.currentStepIntroduction : [];
            
            return {
                id: practicalSnap.id,
                ...guideData,
                components: components,
                connections: connections,
                code: code,
                currentStepIntroduction: currentStepIntroduction,
                name: guideData.name || guideData.project?.name,
                InitialProjectDescription: guideData.InitialProjectDescription || '',
                introduction: guideData.introduction || [],
                titleIntroduction: guideData.titleIntroduction || ''
            };
        }
        
        // Intentar en la colección academyCourses
        console.log("[DEBUG] Intentando buscar en colección 'academyCourses'");
        const coursesSnapshot = await getDocs(collection(db, 'academyCourses'));
        
        for (const courseDoc of coursesSnapshot.docs) {
            const courseData = courseDoc.data();
            if (courseData.modules) {
                for (const module of courseData.modules) {
                    if (module.lessons) {
                        for (const lesson of module.lessons) {
                            const foundActivity = lesson.classActivities?.find(
                                activity => activity.id === starterId
                            );
                            
                            if (foundActivity) {
                                console.log("[DEBUG] Actividad encontrada en curso:", courseDoc.id);
                                return {
                                    id: foundActivity.id,
                                    ...foundActivity,
                                    components: [],
                                    connections: [],
                                    currentStepIntroduction: [],
                                    courseId: courseDoc.id,
                                    moduleId: module.id
                                };
                            }
                        }
                    }
                }
            }
        }
        
        console.error("[DEBUG] No se encontró el guide en ninguna colección");
        throw new Error('Guide no encontrado en ninguna colección');
    } catch (error) {
        console.error("[DEBUG] Error al buscar guide:", error);
        throw error;
    }
  },

  isRemoteCourseOrGroup: (obj) => {
    if (!obj) return false;
    if (typeof obj.isRemote === "boolean") return obj.isRemote;
    if (obj.course && typeof obj.course.isRemote === "boolean") return obj.course.isRemote;
    return false;
  },

  getTutorGroupActivities: async (tutorId) => {
    try {
      // Obtener todos los grupos donde el usuario es tutor
      const tutorGroups = await academyData.getGroupsByTutorId(tutorId);
      
      // Obtener todas las actividades del tutor en los grupos
      const groupActivities = [];
      
      for (const group of tutorGroups) {
        if (group.activities) {
          // Filtrar las actividades del tutor que tienen projectUid
          const tutorActivities = group.activities.filter(
            activity => activity.mentorUid === tutorId && activity.projectUid
          );
          groupActivities.push(...tutorActivities);
        }
      }
      
      // Extraer los IDs de los proyectos únicos
      const projectIds = [...new Set(groupActivities.map(activity => activity.projectUid))];
          
      return projectIds;
    } catch (error) {
      console.error('Error getting tutor group activities:', error);
      return [];
    }
  },
};

export default academyData;
